import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Button, InputNumber, Select} from 'antd'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('roleManagementStore')
@observer
class FormModal extends Component {
  state = {}
  formRef = React.createRef()

  componentDidMount() {
    const {roleManagementStore, title} = this.props
    const {detailsObj} = roleManagementStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        name: detailsObj.name,
        key: detailsObj.key,
        description: detailsObj.description,
        harnessAllowedTools: Array.from(detailsObj.harnessAllowedTools || []),
        harnessApprovalTools: Array.from(detailsObj.harnessApprovalTools || []),
        harnessPriority: detailsObj.harnessPriority
      })
    } else {
      this.formRef.current.setFieldsValue({
        name: '',
        key: '',
        description: '',
        harnessAllowedTools: [],
        harnessApprovalTools: []
      })
    }
  }

  handleOk = () => {
    const {roleManagementStore, handleCancel, title} = this.props
    const {detailsObj} = roleManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if (title === 'edit') {
        roleManagementStore.onEditRoleAction(fieldsValue, detailsObj.id)
      } else {
        roleManagementStore.onChangePageNo()
        roleManagementStore.onAddRoleAction(fieldsValue)
      }
      handleCancel()
    }).catch(err => {})

  }

  render() {
    const {addModalVisible, handleCancel, title, t} = this.props
    return (
      <>
        <Modal
          title={title === 'edit' ? `${t(`general.edit`)} ${t(`roleManagement.role`)}` : `${t(`general.add`)} ${t(`roleManagement.role`)}`}
          closable={true}
          onCancel={handleCancel}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="name" label={t(`roleManagement.roleName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`roleManagement.roleName`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="key" label={t(`roleManagement.roleCode`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`roleManagement.roleCode`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <div style={{marginBottom: 12, color: '#777', fontSize: 12}}>
                  Harness 统一使用 enterprise-general；本角色只配置可调用工具和审批策略。
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="harnessAllowedTools" label={t(`roleManagement.harnessAllowedTools`)}>
                  <Select mode="tags" tokenSeparators={[',']} placeholder="enterprise_data_*, web_search"/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="harnessApprovalTools" label={t(`roleManagement.harnessApprovalTools`)}>
                  <Select mode="tags" tokenSeparators={[',']} placeholder="bash, mcp_file_write"/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="harnessPriority" label={t(`roleManagement.harnessPriority`)}>
                  <InputNumber min={0} precision={0} style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="description" label={t(`roleManagement.description`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`roleManagement.description`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <TextArea rows={4}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
